var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 9.5,
    fill: "#F8C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14C2.5 14.9849 2.69399 15.9602 3.0709 16.8701C3.44781 17.7801 4.00026 18.6069 4.6967 19.3033C5.39314 19.9997 6.21993 20.5522 7.12987 20.9291C8.03982 21.306 9.01509 21.5 10 21.5C10.9849 21.5 11.9602 21.306 12.8701 20.9291C13.7801 20.5522 14.6069 19.9997 15.3033 19.3033C15.9997 18.6069 16.5522 17.7801 16.9291 16.8701C17.306 15.9602 17.5 14.9849 17.5 14C17.5 12.0109 16.7098 10.1032 15.3033 8.6967C13.8968 7.29018 11.9891 6.5 10 6.5C8.01088 6.5 6.10322 7.29018 4.6967 8.6967C3.29018 10.1032 2.5 12.0109 2.5 14Z",
    stroke: "#A63233",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.83331V14L12.5 16.5",
    stroke: "#A63233",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsTime);
export default __webpack_public_path__ + "static/media/insights-time.b2693e9a1266f00da4dbc3fa8d43a0ed.svg";
export { ForwardRef as ReactComponent };